import { gsap } from 'gsap'
import React, { useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Link from '../components/link'
import { trackHubSpotFormSubmit } from '../utils/trackFormSubmit'

const AddressLines = ({ text }) =>
	(text || '').split('\n').map((line, index, lines) => (
		<React.Fragment key={index}>
			{line}
			{index < lines.length - 1 && <br />}
		</React.Fragment>
	))

const Overlay = () => {
	const { datoCmsContactInformation: contact } = useStaticQuery(graphql`
		query OverlayContact {
			datoCmsContactInformation {
				addressOneTitle
				addressOne
				addressOneLink
				addressTwoTitle
				addressTwo
				addressTwoLink
			}
		}
	`)

	useEffect(() => {
		document.querySelector('.contact-form--button').addEventListener('click', showContactForm)
		window.hbspt.forms.create({
			region: 'na1',
			portalId: '9226978',
			formId: '1decd293-dfd1-48d5-9846-26202f78a7e1',
			target: '#contact-form',
			onFormSubmit: ($form) => {
				const email = ($form && $form.find && $form.find('input[name="email"]').val())
					|| (document.querySelector('#contact-form input[name="email"]') || {}).value
				trackHubSpotFormSubmit({
					email,
					formGuid: '1decd293-dfd1-48d5-9846-26202f78a7e1',
					formName: 'contact_overlay',
				})
			},
		})
	}, [])

	const showContactForm = e => {
		document.querySelector('.overlay--menu').classList.add('form-active')
		gsap.to('.internal--menu', { autoAlpha: 0, display: 'none', duration: 0.65 })
		gsap.to('.contact--form', { opacity: 1, display: 'block', duration: 0.65, delay: 0.75 })
	}

	const toggleMenu = e => {
		if (!document.querySelector('.form-active')) {
			var menu = document.querySelector('.overlay--menu')
			var masthead = document.querySelector('.masthead')
			if (menu.classList.contains('is-active')) {
				menu.classList.remove('is-active')
				masthead.classList.remove('is-open')
				document.querySelector('.menu--copy').innerHTML = 'Menu'
				document.querySelector('.menu--icon')?.setAttribute('aria-expanded', 'false')
				document.querySelector('.overlay--menu').classList.remove('form-active')
			} else {
				menu.classList.add('is-active')
				masthead.classList.add('is-open')
				document.querySelector('.menu--copy').innerHTML = 'Close'
				document.querySelector('.menu--icon')?.setAttribute('aria-expanded', 'true')
			}
		} else {
			gsap.to('.contact--form', { opacity: 0, display: 'none', duration: 0.65 })
			gsap.to('.internal--menu', { autoAlpha: 1, display: 'block', duration: 0.65, delay: 0.75 })

			document.querySelector('.overlay--menu').classList.remove('form-active')
		}
	}

	useEffect(() => {
		const contactBtns = gsap.utils.toArray('a[href="/contact-form"]')
		contactBtns.forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault()
				toggleMenu()
				showContactForm()
			})
		})
	}, [])

	return (
		<div className='overlay--menu' id='site-menu'>
			<div className='pl40 overlay--inner pr40'>
				<div className='flex h-100 max-1400 ma w-100 overflow-x-hidden'>
					<div className='max-450 w-33 m-hide'></div>
					<div className='flex-grow-1 m-hide'></div>
					<div className='max-450 w-33 flex flex-wrap max-unset m-w-100'>
						<nav className='menu internal--menu w-100 overlay--links uppercase ' aria-label='Primary'>
							<Link className='m0 link flex' to='/'>
								Home <span className='square bg-transition'></span>
							</Link>
							<Link className='m0 link' to='/developments'>
								Developments <span className='square bg-transition'></span>
							</Link>
							<Link className='m0 link' to='/story'>
								Our Story <span className='square bg-transition'></span>
							</Link>
							<Link className='m0 link' to='/insights'>
								Insights <span className='square bg-transition'></span>
							</Link>
							<Link className='m0 link' to='/news'>
								News & Articles<span className='square bg-transition'></span>
							</Link>
							<p className='m0 contact-form--button link'>
								Contact <span className='square bg-transition'></span>
							</p>
						</nav>
						<div className='contact--form '>
							<div className='h-100 flex'>
								<div class='mta' id='contact-form'></div>
							</div>
						</div>
						<div className='contact information w-100 mta pb40 pt40 uppercase'>
							<div className='flex'>
								<div className='details'>
									<p className='m0 mb10'>Details</p>
									<a href='tel:1300 474 372' className='link ul-link mb5 inline'>
										1300 474 372
									</a>
									<br />
									<a href='mailto:admin@sieragroup.com.au' className='link ul-link mb5 inline'>
										admin@sieragroup.com.au
									</a>
								</div>
								<div className='details mla'>
									<p className='m0 mb10'>Follow</p>
									<a href='https://www.facebook.com/sieragroup/' rel='noreferrer' target='_blank' className='link ul-link mb5 inline'>
										Facebook
									<span className='sr-only'> (opens in new tab)</span></a>
									<br />
									<a href='https://www.instagram.com/sieragroup/' rel='noreferrer' target='_blank' className='link ul-link mb5 inline'>
										instagram
									<span className='sr-only'> (opens in new tab)</span></a>
									<br />
									<a className='link ul-link mb5 inline' target='_blank' rel='noreferrer' href='https://www.youtube.com/channel/UCvCNr4mtCh0Ob4nwH_7RStA'>
										Youtube
									<span className='sr-only'> (opens in new tab)</span></a>
									<br />
									<a href='https://www.linkedin.com/company/siera-group' rel='noreferrer' target='_blank' className='link ul-link mb5 inline'>
										Linkedin
									<span className='sr-only'> (opens in new tab)</span></a>
								</div>
							</div>
							<div className='flex mt40 m-wrap'>
								<div className='details m-100'>
									<p className='m0 mb10'>{contact?.addressOneTitle}</p>
									<a href={contact?.addressOneLink} rel='noreferrer' target='_blank' className='link ul-link inline'>
										<AddressLines text={contact?.addressOne} /><span className='sr-only'> (opens in new tab)</span>
									</a>
								</div>
								<div className='details mla m-100 m-mt20'>
									<p className='m0 mb10'>{contact?.addressTwoTitle}</p>
									<a href={contact?.addressTwoLink} rel='noreferrer' target='_blank' className='link ul-link inline'>
										<AddressLines text={contact?.addressTwo} /><span className='sr-only'> (opens in new tab)</span>
									</a>
								</div>
							</div>
							<div className='m-show m-pt20'>
								<span className='m0'>ACN: 643 263 272</span> <br /> <span className='m0'>ABN: 86 643 263 272</span> <br /> <span className='m0'>QBCC: 15336339</span>
							</div>
							<div className='spacer'></div>
							<p className='m0 flex justify-between slim m-hide'>
								<span>ACN: 643 263 272</span> <span>|</span> <span>ABN: 86 643 263 272</span> <span>|</span> <span>QBCC: 15336339</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
export default Overlay
